import { memo } from 'react';

import { UserRoundPlusIcon, UsersIcon } from '@air/design-icons';
import { Badge } from '@air/primitive-badge';
import { DropdownMenuItem } from '@air/primitive-dropdown-menu';
import { cn } from '@air/utils-tailwind';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type WorkspaceHeaderInformationDropdownTeamInviteNudgeProps = {
  onInviteMembers: () => void;
  shouldRoundTopCorners: boolean;
};

export const WorkspaceHeaderInformationDropdownTeamInviteNudge = memo(
  ({ onInviteMembers, shouldRoundTopCorners }: WorkspaceHeaderInformationDropdownTeamInviteNudgeProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <>
        <div
          className={cn(
            '-mx-2 -mt-2 ads:bg-primary-subtle bg-blue-1 px-3 py-3',
            shouldRoundTopCorners && 'ui2026:rounded-t-8',
          )}
          data-testid="WORKSPACE_DROPDOWN_TEAM_INVITE_NUDGE"
        >
          <p className="font-semibold ads:text-primary text-14 text-gray-12">Gather your team in Air</p>
          <p className="mt-1 ads:text-primary text-14 text-gray-12">
            All plans have unlimited seats to make collaboration seamless.
          </p>
        </div>
        <DropdownMenuItem
          data-id="INVITE_USERS"
          label="Invite users"
          onSelect={onInviteMembers}
          prefix={
            ui2026 ? (
              <UsersIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />
            ) : (
              <UserRoundPlusIcon size="sm" />
            )
          }
          suffix={
            <Badge className="shrink-0" color="blue">
              Unlimited
            </Badge>
          }
        />
      </>
    );
  },
);

WorkspaceHeaderInformationDropdownTeamInviteNudge.displayName = 'WorkspaceHeaderInformationDropdownTeamInviteNudge';
